<template>
  <BaseLayout>
    <TimelineLoading :step="loadStep" :loading="isLoading" class="h-full w-full min-h-full">
      <div class="flex flex-row items-center justify-center w-full">
        <div class="flex flex-row sm:py-10 w-full sm:w-2/3 xl:w-1/2 items-center justify-center">
          <OfferDetailContext step="PAGAMENTO" id="page-payment" :offer="offer" :isAccordionOpen="true" :keepAccordionOpen="true" :colorSolid="true">
            <div class="flex-1 flex flex-col items-start gap-2 sm:gap-10 w-full">
              <iframe ref="smartCheckoutIframe" class="square" :src="iframeUrl" allow="payment; clipboard-read; clipboard-write; publickey-credentials-get; publickey-credentials-create;"></iframe>
            </div>
          </OfferDetailContext>
        </div>
      </div>
    </TimelineLoading>
  </BaseLayout>
</template>

<style>
  .square {
    width: 100%;
    height: 100%;
    min-height: 500px;
  }
</style>

<script>
import TimelineLoading from '../../components/TimelineLoading.vue'
import { loadUserDataMixin } from '@/business/user/mixins'
import { useHttpServiceMixin } from '@/common/use-http'
import { serviceBuilder as paymentService } from '@/business/payment/service'
import { serviceBuilder as userService } from '@/business/user/service'
import { SuccessfulTransaction } from '@/business/domain/SuccessfulTransaction'
import dayjs from 'dayjs'
import { manageConfirmationMixin } from '@/business/payment/mixins'
import { singleOfferMixin } from '@/business/offers/mixins'
import OfferDetailContext from '../../components/OfferDetailContext.vue'
import store from '../../business/store'
import { CURRENT_OFFER_KEY, SMS_STORE_ORIGIN_KEY, SMS_STORE_TELEVENDAS_ID_KEY } from '../../common/constants'
import { NotifyUserActionsEnum } from '../../business/http/dto/NotifyUserActionRequest'
import { loadPedidoVendaId } from '@/business/televendas/pedido-venda-id'

export default {
  name: 'page-3-step',
  title: 'Pagamento',
  components: { TimelineLoading, OfferDetailContext },
  mixins: [
    manageConfirmationMixin,
    loadUserDataMixin,
    singleOfferMixin,
    useHttpServiceMixin({ paymentService, userService })
  ],
  data () {
    return {
      isIframeLoading: true,
      sessionToken: null
    }
  },
  computed: {
    isLoading () {
      return this.isOfferLoading || this.isIframeLoading
    },
    iframeUrl () {
      return `${process.env.VUE_APP_SMARTCHECKOUT_IFRAME}?code=${this.sessionToken}`
    }
  },
  async mounted () {
    const response = await this.$paymentService.createIzzieSession().then((data) => {
      return data
    }).catch(() => {
      this.$router.replace({
        name: 'page-payment-error',
        params: { linkTo: '/3-step-smartcheckout' }
      })
    })

    this.sessionToken = response

    const iframe = this.$refs.smartCheckoutIframe
    iframe.addEventListener('load', () => {
      this.isIframeLoading = false
    })
    window.addEventListener('message', this.handleMessage, false)
  },
  methods: {
    async handleMessage (event) {
      if (!event.data || !event.data.status) return
      if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SMARTCHECKOUT_IFRAME.replace('/checkout/', '') !== event.origin) {
        return
      }

      const { data } = event

      const isSucesso = data.status === 'CONFIRMED' || data.status === 'PENDING'
      this.saveIframeResponse(data.correlationId, isSucesso ? 'SUCESSO' : 'ERRO', this.userData.msisdn, data.transactions ? data.transactions[0]?.reason : null)

      if (isSucesso) {
        const { userData: { msisdn } } = this
        const { brand, lastDigits } = data.transactions[0].card
        const confirmation = new SuccessfulTransaction(dayjs(), lastDigits, brand, msisdn)
        await this.storeSuccessfulTransaction(confirmation)
        this.saveNegociacaoAcao(msisdn)
        this.$router.replace({
          name: 'page-success'
        })
      } else {
        this.$router.replace({
          name: 'page-payment-error',
          params: { linkTo: '/3-step-smartcheckout' }
        })
      }
    },
    async saveIframeResponse (correlationId, status, msisdn, reasonFailure) {
      const pedidoVendaId = await loadPedidoVendaId()
      const response = {
        correlationId,
        msisdn,
        status,
        reasonFailure: status === 'SUCESSO' ? null : this.parseReasonFailure(reasonFailure),
        ...(pedidoVendaId && { pedidoVendaId })
      }
      await this.$paymentService.saveIframeResponse(response)
    },
    parseReasonFailure (reason) {
      if (!reason) return null

      reason = reason.replace(/\s+/g, ' ').replace(/[^a-zA-Z0-9{}":,[\] ]/g, '').trim()

      const parts = reason.split(' - ')

      if (parts.length < 3) return reason

      const [paymentMethod, statusCode, ...rest] = parts
      const reasonMessage = rest.join(' - ')
      return `{
        paymentMethod: ${paymentMethod},
        statusCode: ${statusCode},
        reason: ${reasonMessage}
      }`.trim()
    },
    async saveNegociacaoAcao (msisdn) {
      try {
        const offerId = await store.get(CURRENT_OFFER_KEY)
        const origin = await store.get(SMS_STORE_ORIGIN_KEY)
        const televendasId = await store.get(SMS_STORE_TELEVENDAS_ID_KEY)
        const extra = { offerId, origin }
        await this.$userService.notifyUserActionWithTelevendasId(msisdn, NotifyUserActionsEnum.ADESAO, extra, televendasId)
      } catch (error) {
        this.$tracker.error(error)
      }
    }
  }
}
</script>
